import {useActiveCartId, useGoToCart} from '../index';


/**
 * @return {(function({string}, {boolean}): null)|*} Go to cart function requiring cartId as parameter
 */
function useGoToActiveCart() {

    const activeCartId = useActiveCartId();
    const goToCart = useGoToCart();

    return (doReplace = false) => goToCart(activeCartId, doReplace);
}


export default useGoToActiveCart;
